function setNativeValue(element, value) {
  var _a = (Object.getOwnPropertyDescriptor(element, 'value') || {}).set,
      valueSetter = _a === void 0 ? undefined : _a;
  var prototype = Object.getPrototypeOf(element);
  var _b = (Object.getOwnPropertyDescriptor(prototype, 'value') || {}).set,
      prototypeValueSetter = _b === void 0 ? undefined : _b;

  if (prototypeValueSetter && valueSetter !== prototypeValueSetter) {
    prototypeValueSetter.call(element, value);
  } else if (valueSetter) {
    valueSetter.call(element, value);
  } else {
    throw new Error('The given element does not have a value setter');
  }
}

export var triggerChangeEvent = function triggerChangeEvent(node, value) {
  setNativeValue(node, value);
  var event;

  if (typeof Event === 'function') {
    event = new Event('input', {
      bubbles: true
    });
  } else {
    event = document.createEvent('Event');
    event.initEvent('input', true, true);
  }

  node.dispatchEvent(event);
};